import type { CustomStep } from "../types/types";

export const PossibleStepsLabels = {
  dateTime: "Выбрать дату и время",
  employee: "Выбрать специалиста",
  details: "Заполнить детали",
} as const;

export const PossibleStepsTypes = {
  dateTime: "dateTime",
  employee: "employee",
  details: "details",
} as const;

export const StepIconMap = {
  [PossibleStepsLabels.dateTime]: (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path
        d="M6.66406 1.66602V4.99935"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M13.3359 1.66602V4.99935"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15.8333 3.33203H4.16667C3.24619 3.33203 2.5 4.07822 2.5 4.9987V16.6654C2.5 17.5858 3.24619 18.332 4.16667 18.332H15.8333C16.7538 18.332 17.5 17.5858 17.5 16.6654V4.9987C17.5 4.07822 16.7538 3.33203 15.8333 3.33203Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M2.5 8.33203H17.5"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.66406 11.666H6.6724"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10 11.666H10.0083"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M13.3359 11.666H13.3443"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.66406 15H6.6724"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10 15H10.0083"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M13.3359 15H13.3443"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  ),
  [PossibleStepsLabels.details]: (
    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="19" viewBox="0 0 15 19" fill="none">
      <path
        d="M4.08594 0.75V4.08333"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.41406 0.75V4.08333"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10.75 0.75V4.08333"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.4167 2.41602H2.41667C1.49619 2.41602 0.75 3.16221 0.75 4.08268V15.7493C0.75 16.6698 1.49619 17.416 2.41667 17.416H12.4167C13.3371 17.416 14.0833 16.6698 14.0833 15.7493V4.08268C14.0833 3.16221 13.3371 2.41602 12.4167 2.41602Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M4.08594 7.41602H9.08594"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M4.08594 10.75H10.7526"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M4.08594 14.084H8.2526"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  ),
  [PossibleStepsLabels.employee]: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.9974 17.5007C14.9974 15.7325 14.295 14.0368 13.0448 12.7866C11.7945 11.5364 10.0988 10.834 8.33073 10.834C6.56262 10.834 4.86693 11.5364 3.61668 12.7866C2.36644 14.0368 1.66406 15.7325 1.66406 17.5007"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8.33073 10.8333C10.6319 10.8333 12.4974 8.96785 12.4974 6.66667C12.4974 4.36548 10.6319 2.5 8.33073 2.5C6.02954 2.5 4.16406 4.36548 4.16406 6.66667C4.16406 8.96785 6.02954 10.8333 8.33073 10.8333Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M18.3333 16.6673C18.3333 13.859 16.6667 11.2507 15 10.0007C15.5478 9.58963 15.9859 9.04989 16.2755 8.42921C16.565 7.80853 16.6971 7.12604 16.66 6.44215C16.6229 5.75826 16.4178 5.09406 16.0629 4.50832C15.7079 3.92258 15.2141 3.43337 14.625 3.08398"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  ),
  ["finish"]: (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path
        d="M16.6693 5.41602L7.5026 14.5827L3.33594 10.416"
        stroke="white"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  ),
};

export const DefaultStepValues = {
  specialtyFirst: [
    {
      title: PossibleStepsLabels.employee,
      status: "wait",
      icon: StepIconMap[PossibleStepsLabels.employee],
      type: "employee",
    },
    {
      title: PossibleStepsLabels.dateTime,
      status: "wait",
      icon: StepIconMap[PossibleStepsLabels.dateTime],
      type: "dateTime",
    },
    {
      title: PossibleStepsLabels.details,
      status: "wait",
      icon: StepIconMap[PossibleStepsLabels.details],
      type: "details",
    },
  ] as CustomStep[],
  schedulFirst: [
    {
      title: PossibleStepsLabels.dateTime,
      status: "wait",
      icon: StepIconMap[PossibleStepsLabels.dateTime],
      type: "dateTime",
    },
    {
      title: PossibleStepsLabels.employee,
      status: "wait",
      icon: StepIconMap[PossibleStepsLabels.employee],
      type: "employee",
    },
    {
      title: PossibleStepsLabels.details,
      status: "wait",
      icon: StepIconMap[PossibleStepsLabels.details],
      type: "details",
    },
  ] as CustomStep[],
} as const;
